import React from 'react'
import Navbar from '../../components/layouts/Navbar';
import Footer from '../../components/layouts/Footer';
import DiscoveryButton from '../../components/DiscoveryButton';
import './about.css';

import placeholder from '../../images/img placeholder.png'




const committee = ({ data }) => {
    return (
        <div>
            <Navbar />
            <div className="about">
                <h1 className="about-header">Committee Members</h1>
                <div className="card-container">

                {data.allDirectusCommitteeMember.edges.map(member => (
                    <div className="member-card">
                        <div className="member-wrapper">
                            <div className="member-img">
                                <img src={member.node.image.data.full_url} alt=""/>
                            </div>
                            <div className="text-container">
                                <h2 className="member-title">{member.node.name}</h2>
                                <p className="member-desc">{member.node.role}</p>
                                <p className="member-desc">{member.node.email}</p>
                                <p className="member-desc">{member.node.phone_number}</p>
                            </div>
                        </div>
                    </div>
                ))}
                    
                    

                    
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default committee;
export const pageQuery = graphql`             
query committeeQuery {
    allDirectusCommitteeMember {
      edges {
        node {
          email
          name
          phone_number
          role
          image {
            data {
              full_url
            }
          }
        }
      }
    }
  }
`